<template>
  <main class="receipt">
    <menu-venda-recebimento />
    <section class="receipt-content-container">
      <transition
        name="fade"
        mode="out-in">
        <router-view />
      </transition>
    </section>
  </main>
</template>

<script>
import MenuVendaRecebimento from "@/components/MenuVendaRecebimento";

export default {
  components: {
    MenuVendaRecebimento
  }
};
</script>

<style scoped lang="scss">
.receipt {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  height: 100%;
}
.receipt-content-container {
  flex: 1;
  width: 100%;
  padding: 2rem 0 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
